import { defineMessages } from 'react-intl';

export default defineMessages({
  invalid: {
    id: 'app.components.FlexCounter.invalid',
    defaultMessage: 'Item obrigatório',
  },
  numeroBanheiros: {
    id: 'app.components.FlexCounter.numeroBanheiros',
    defaultMessage: 'Nº de banheiros',
  },
  numeroQuartos: {
    id: 'app.components.FlexCounter.numeroQuartos',
    defaultMessage: 'Nº de quartos',
  },
  numeroSuites: {
    id: 'app.components.FlexCounter.numeroSuites',
    defaultMessage: 'Nº de suítes',
  },
});
